//@ts-nocheck
import { memo, FunctionComponent } from 'react';
import COLORS from '../../theme/Colors';
import { Container, StyledTextField } from './styles/TextFieldStyles';
import { FieldTitle, Row } from '../../theme/Styles';
import CircularProgress from '@mui/material/CircularProgress';
import CheckRender from '../CheckRender/CheckRender';
import { KeyboardEventHandler } from 'react';

const TextField: FunctionComponent<propTypes> = (props) => {
    return (
        <Container>
                <Row>
                    <FieldTitle>{props.title} </FieldTitle>
                    <div style={{ width: '5px' }} />
                    <CheckRender allowed={props.required}>
                        <FieldTitle style={{ color: COLORS.red }}>*</FieldTitle>
                    </CheckRender>
                </Row>

            <StyledTextField
                fullWidth
            //    hideBorder={props.hideBorder}
                disabled={props.disabled}
                multiline={props.multiline}
                id={props.id}
                placeholder={props.placeholder}
                value={props.value}
                onBlur={props.onBlur}
                onChange={props.onChange}
                onKeyDown={props.onKeyDown}
                type={props.type}
                helperText={props.helperText}
                FormHelperTextProps={{ sx: { fontSize: '0.90rem' } }}
                error={props.error}
                minRows={props.minRows}
                maxRows={props.maxRows}
                maxLength={props.maxLength}
                minLength={props.minLength}
                autoFocus={props.autoFocus}
                inputProps={{
                    maxLength: props.maxLength,
                    minLength: props.minLength,
                    max: props.max,
                    min: props.min,

                }}
                InputProps={{
                    endAdornment: props.isLoading ?
                        <CircularProgress size='1em' />
                        :
                        props.endAdornment,
                    startAdornment: props.startAdornment
                }}
            />
        </Container>
    );
};

export interface propTypes {
    id: string;
    title?: string;
    placeholder?: string;
    value: string | number | undefined;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEventHandler<HTMLInputElement> ) => void;
    type?: string;
    error?: boolean;
    mask?: string;
    unMaskedValue?: boolean;
    hideBorder?: boolean;
    required?: boolean;
    multiline?: boolean;
    minLength?: number;
    maxLength?: number;
    max?: number;
    min?: number;
    disabled?: boolean;
    isLoading?: boolean;
    endAdornment?: any;
    startAdornment?: React.ReactNode;
    helperText?: string | boolean;
    minRows?: number;
    maxRows?: number;
    autoFocus? :boolean;
}

TextField.defaultProps = {
    helperText: " ",
    minRows: 2,
    hideBorder: false,
    autoFocus:false
}

export default memo(TextField);